import { render, staticRenderFns } from "./RadioButton.vue?vue&type=template&id=2bb507fc&scoped=true&"
import script from "./RadioButton.vue?vue&type=script&lang=ts&"
export * from "./RadioButton.vue?vue&type=script&lang=ts&"
import style0 from "./RadioButton.vue?vue&type=style&index=0&id=2bb507fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb507fc",
  null
  
)

export default component.exports